<template>
  <div id="ExportManage" class="well" style="padding: 0 1em">
    <b-tabs content-class="mt-3" justified>
      <b-tab :active="dataMode == 0" :disabled="dataMode != 0">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請學年度：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如112"
                  />
                </th>

                <th style="min-width: 6em">學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>
                <th style="min-width: 5em">競賽種類名稱:</th>
                <th style="min-width: 15em">
                  <!--
              <b-form-select v-model="queryInfo.typeName">
                <option
                  v-for="(selectOption, indexOpt) in TypeNameList"
                  :key="indexOpt"
                  :value="selectOption.typeName"
                  v-on:change="getSelected1Item(selectOption.typeName)"
                >
                  {{ selectOption.typeName }}
                </option>

              </b-form-select> -->
                  <div>
                    <select v-model="queryInfo.sn">
                      <option selected="selected" value="">
                        請選擇競賽種類名稱
                      </option>
                      <option
                        v-for="typeNameSet in TypeNameList"
                        :key="typeNameSet.sn"
                        :value="typeNameSet.sn"
                      >
                        {{ typeNameSet.typeName }}
                      </option>
                    </select>
                  </div>
                </th>

                <th style="min-width: 12em">
                  <b-button variant="success" tabindex="3" @click="query()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
  style="margin: 0 0.5rem; text-decoration: none"
  target="_blank"
  tabindex="4"
  class="ncut-excel-style"
  :href="`./WebApi/SportsExcellent/GetSportsCSV/${queryInfo.STime},${queryInfo.ETime},${queryInfo.sn}`"
  v-show="total > 0"
>
  <img
    src="@/assets/images/ods-file24.png"
    style="height: 0.8rem"
    alt="CSV Icon"
  />
  {{ $t("message.CSV_txt") }}共 {{ total }} 筆

</a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 5em">身分證字號</th>
                <th style="min-width: 5em">姓名</th>

                <th style="min-width: 10em">帳號</th>

                <th style="min-width: 7em">銀行代碼</th>
                <th style="min-width: 5em">職別(稱)</th>
                <th style="min-width: 15em">戶籍地址</th>
                <th style="min-width: 2em">身份別代碼</th>
                <th style="min-width: 2em">單位(ex:時,月,次...)</th>
                <th style="min-width: 2em">數量</th>
                <th style="min-width: 2em">單價</th>
                <th style="min-width: 2em">機關負擔勞保費</th>
                <th style="min-width: 2em">機關負擔補充保費</th>

                <th style="min-width: 2em">機關負擔勞退金</th>
                <th style="min-width: 2em">機關負擔離職金</th>
                <th style="min-width: 2em">個人自付勞保費</th>
                <th style="min-width: 2em">個人自付補充保費</th>
                <th style="min-width: 2em">個人自付勞退金</th>
                <th style="min-width: 2em">個人自付離職金</th>
                <th style="min-width: 2em">代扣所得</th>
                <th style="min-width: 2em">其他代扣</th>
                <th style="min-width: 2em">免稅給付</th>
                <th style="min-width: 2em">說明</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.monthDay"
                :index="item.monthDay"
                :name="item.monthDay"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.idno }}
                </td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.postno }}</td>
                <td style="text-align: left">{{ item.postsubID }}</td>
                <td style="text-align: left"></td>
                <td style="text-align: left">{{ item.hmadd1 }}</td>
                <td style="text-align: left">{{ 5 }}</td>
                <td style="text-align: left">人</td>
                <td style="text-align: left">1</td>
                <td style="text-align: left">{{ item.money }}</td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
                <td style="text-align: left"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from "../tool";
export default {
  name: "ExportManage",
  data() {
    return {
      TypeNameList: null,
      total: 0,
      dataMode: 0,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        sn:0,
        STime: null,
        ETime: null,
        typeName: null,
      },
      docRecordList: null,
    };
  },

  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    setting() {
      return this.$store.getters.getSetting;
    },

    filteredDocs: function () {
      let data = [];
      if (this.docRecordList != null) {
        data = this.docRecordList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  filters: {},
  methods: {
    getSelected1Item(typeName) {
      this.queryInfo.typeName = typeName;
    },
    checkSaveData() {
      let msg = "";
      if (this.queryInfo.STime == null) msg = "請輸入申請學年度";
      else if (this.queryInfo.ETime == null) msg = "請輸入學期";
      else if (this.queryInfo.sn == 0) msg = "請選擇競賽種類名稱";
      return msg;
    },
    query() {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;
        // vm.queryInfo.dataMode = vm.dataMode;

        this.$http
          .put("./WebApi/SportsExcellent/GetSportsList3", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
    getAllTypeName(mode) {
      let vm = this;
      this.$http
        .get("./WebApi/SportsExcellent/GetAllTypeName/".concat(mode))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.TypeNameList = response.data;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
  },
  created() {
    console.log("======created ExportManageView =====");
    this.getAllTypeName(1);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
